export default "__VITE_ASSET__Crqlo9V0__$_?nuxt_component=async&nuxt_component_name=SvgoGeodnetLogo&nuxt_component_export=default__"